import {
  LayoutDashboard,
  Settings,
  UserCog,
  UserPlus,
  Key,
  Package,
  ShoppingCart,
  Users,
  Shield,
  Tag,
  Truck,
  MessageSquare,
  Wallet,
  FileText,
  Percent,
  Store,
  UserCheck,
  ClipboardList,
  Building2,
  PackageSearch,
  Clock,
  KeyRound,
  Code,
  Link,
  ShieldCheck,
  Landmark,
  Megaphone,
  PackageX,
  Star,
  LineChart,
  BarChart,
  Globe,
  ToggleLeft,
  Cog,
  KeySquare,
  Download,
  PackagePlus
} from 'lucide-react';

export interface MenuItem {
  id: string;
  label: string;
  path?: string;
  icon: any;
  adminOnly?: boolean;
  subItems?: MenuItem[];
}

export const menuItems: MenuItem[] = [
  {
    id: 'dashboard',
    icon: LayoutDashboard,
    label: 'Dashboard',
    path: '/dashboard'
  },
  {
    id: 'products',
    icon: Package,
    label: 'Produtos',
    subItems: [
      {
        id: 'products-list',
        icon: Package,
        label: 'Lista de Produtos',
        path: '/dashboard/products'
      },
      {
        id: 'products-approvals',
        icon: Package,
        label: 'Aprovações',
        path: '/dashboard/products/pending',
        adminOnly: true
      }
    ]
  },
  {
    id: 'reviews',
    icon: Star,
    label: 'Reviews',
    path: '/dashboard/reviews'
  },
  {
    id: 'pricebench',
    icon: LineChart,
    label: 'Pricebench',
    path: '/dashboard/pricebench'
  },
  {
    id: 'fulfillment',
    icon: Truck,
    label: 'Fulfillment Stock',
    path: '/dashboard/fulfillment/stock'
  },
  {
    id: 'drop',
    icon: Tag,
    label: 'Area Drop',
    path: '/dashboard/drop'
  },
  {
    id: 'orders',
    icon: ShoppingCart,
    label: 'Pedidos & Vendas',
    subItems: [
      {
        id: 'orders-list',
        icon: ShoppingCart,
        label: 'Pedidos',
        path: '/dashboard/orders'
      },
      {
        id: 'invoices',
        icon: FileText,
        label: 'Faturas',
        path: '/dashboard/invoices'
      },
      {
        id: 'vouchers',
        icon: Percent,
        label: 'Vouchers',
        path: '/dashboard/vouchers'
      }
    ]
  },
  {
    id: 'multichannel',
    icon: Globe,
    label: 'Multicanal',
    subItems: [
      {
        id: 'multichannel-orders',
        icon: ShoppingCart,
        label: 'Pedidos Externos',
        path: '/dashboard/multicanal/external-orders'
      },
      {
        id: 'multichannel-submit',
        icon: Package,
        label: 'Submeter Produtos',
        path: '/dashboard/multicanal/products/submit'
      },
      {
        id: 'multichannel-products',
        icon: Package,
        label: 'Os Meus Produtos',
        path: '/dashboard/multicanal/products/my'
      },
      {
        id: 'multichannel-approvals',
        icon: ClipboardList,
        label: 'Anúncios Marketplaces',
        path: '/dashboard/multicanal/products/approval',
        adminOnly: true
      },
      {
        id: 'multichannel-activations',
        icon: ToggleLeft,
        label: 'Ativações',
        path: '/dashboard/multicanal/activations'
      },
      {
        id: 'multichannel-settings',
        icon: Cog,
        label: 'Configurações',
        path: '/dashboard/multicanal/settings',
        adminOnly: true
      }
    ]
  },
  {
    id: 'shipping',
    icon: Truck,
    label: 'Envios',
    subItems: [
      {
        id: '/dashboard/shipping',
        icon: Package,
        label: 'Os meus envios',
        path: '/dashboard/shipping'
      },
      {
        id: '/dashboard/shipping/pickups',
        icon: Truck,
        label: 'As minhas recolhas',
        path: '/dashboard/shipping/pickups'
      },
      {
        id: '/dashboard/shipping/report',
        icon: BarChart,
        label: 'Relatório',
        path: '/dashboard/shipping/report'
      },
      {
        id: '/dashboard/shipping/settings',
        icon: Settings,
        label: 'Configurações',
        path: '/dashboard/shipping/settings'
      }
    ]
  },
  {
    icon: Users,
    label: 'Social',
    path: '/dashboard/social'
  },
  {
    icon: MessageSquare,
    label: 'Mensagens',
    path: '/dashboard/messages'
  },

  {
    id: 'marketplace',
    icon: Store,
    label: 'Marketplace',
    adminOnly: true,
    subItems: [
      {
        id: 'marketplace-clients',
        icon: UserCheck,
        label: 'Clientes',
        path: '/dashboard/marketplace/clients',
        adminOnly: true
      },
      {
        id: 'marketplace-orders',
        icon: ShoppingCart,
        label: 'Encomendas',
        path: '/dashboard/marketplace/orders',
        adminOnly: true
      },
      {
        id: 'marketplace-cancellations',
        icon: ClipboardList,
        label: 'Cancelamentos',
        path: '/dashboard/marketplace/cancellations',
        adminOnly: true
      },
      {
        id: 'marketplace-commissions',
        icon: Percent,
        label: 'Comissões',
        path: '/dashboard/commissions',
        adminOnly: true
      },
      {
        id: 'marketplace-treasury',
        icon: Landmark,
        label: 'Tesouraria',
        path: '/dashboard/treasury',
        adminOnly: true
      },
      {
        id: 'marketplace-settings',
        icon: Settings,
        label: 'Definições',
        path: '/dashboard/marketplace/settings',
        adminOnly: true
      }
    ]
  },
  {
    id: 'integrations',
    icon: Link,
    label: 'Integrações',
    subItems: [
      {
        id: 'integrations-settings',
        icon: Store,
        label: 'Configurações',
        path: '/dashboard/integrations/settings'
      }
    ]
  },
  {
    id: 'import',
    icon: Download,
    label: 'Importação',
    subItems: [
      {
        id: 'import-products',
        icon: PackagePlus,
        label: 'Importar',
        path: '/dashboard/import'
      }
    ]
  },
  {
    id: 'settings',
    icon: Settings,
    label: 'Configurações',
    path: '/dashboard/settings',
    subItems: [
      {
        id: '/dashboard/settings/store',
        icon: Store,
        label: 'Loja Online',
        path: '/dashboard/settings/store'
      },
      {
        id: '/dashboard/settings/api-keys',
        icon: KeySquare,
        label: 'API Keys',
        path: '/dashboard/settings/api-keys'
      },
      {
        id: 'settings-user-roles',
        icon: UserCog,
        label: 'Função de Utilizadores',
        path: '/dashboard/settings/user-roles',
        adminOnly: true
      },
      {
        id: '/dashboard/settings/payments',
        icon: Wallet,
        label: 'Pagamentos',
        path: '/dashboard/settings/payments',
        adminOnly: true
      },
      {
        id: '/dashboard/settings/shipping',
        icon: Truck,
        label: 'Expedição',
        path: '/dashboard/settings/shipping'
      },
      {
        id: '/dashboard/settings/moderation',
        icon: ShieldCheck,
        label: 'Moderação',
        path: '/dashboard/settings/moderation'
      },
      {
        id: '/dashboard/settings/users',
        icon: Users,
        label: 'Utilizadores',
        path: '/dashboard/settings/users'
      },
      {
        id: '/dashboard/settings/users/create',
        icon: UserPlus,
        label: 'Criar Utilizador',
        path: '/dashboard/settings/users/create'
      },
      {
        id: '/dashboard/settings/apis',
        icon: Code,
        label: 'APIs',
        path: '/dashboard/settings/apis'
      },
      {
        id: '/dashboard/settings/tasks',
        icon: ClipboardList,
        label: 'Tarefas',
        path: '/dashboard/settings/tasks'
      },
      {
        id: '/dashboard/settings/token',
        icon: Key,
        label: 'Token',
        path: '/dashboard/settings/token'
      }
    ]
  }
];